<template>
  <byted-input
    size="md"
    v-model="innerValue"
    @keyup.enter="inputEnterHandler"
    :placeholder="placeholder"
    style="width:210px"
  >
    <template slot="append">
      <byted-button @click="searchBtnClickHandler" class="search-btn">
        <byted-icon name="search" class="search-icon"></byted-icon>
      </byted-button>
    </template>
  </byted-input>
</template>

<script>
export default {
  name: 'search',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: $bp_t('请输入', 'common.please_input')
    }
  },
  data() {
    return {
      innerValue: '',
    }
  },
  methods: {
    inputEnterHandler() {
      this.searchBtnClickHandler()
    },
    searchBtnClickHandler() {
      if(this.innerValue === '') return
      this.$emit('valueChanged', this.innerValue)
      this.innerValue = ''
    }
  },
  created() {
    // this.innerValue = this.value;
  }
};
</script>

<style lang="scss" scoped>
.search-btn {
  width: 32px;
  padding: 5px 8px 5px 8px;
  .search-icon {
    margin-bottom: 4px;
  }
}
/deep/.bui-btn {
  min-width: 32px;
}
</style>